<template>
  <!--关于我们页面-->
  <tk-container class="b-g-f" :status="status" @refresh="getInit">
    <!--头部-->
    <my-header slot="header">关于我们</my-header>
    <!--内容-->
    <card v-if="aboutUs" :height="500" :width="100" class="p-12">
      <div v-html="aboutUs"></div>
    </card>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading', // 页面状态
      aboutUs: null // 联系我们内容
    }
  },
  computed: {},
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  methods: {
    async getInit () {
      try {
        this.setStatusBar('dark')
        let res = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/aboutUs').catch(e => {
          return { data: null }
        })
        if (res.data) { this.aboutUs = res.data } else { this.aboutUs = null }
        if (!this.aboutUs) {
          this.status = 'empty'
          return
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep img {
  width: 100%;
}
</style>
